import Vue from 'vue';
import Vuex from 'vuex';

// modules
import global from './global';
import content from './content';
import gallery from './gallery';
import productInfo from './productInfo';
import productOptions from './productOptions';
import productTabs from './productTabs';
import productSidebar from './productSidebar';
import priceInfo from './priceInfo';
import ctas from './ctas';
import cookies from './cookies';
import interstitial from './interstitial';

Vue.use(Vuex);

export const storeSettings = {
  modules: {
    global,
    content,
    gallery,
    productInfo,
    productOptions,
    productTabs,
    productSidebar,
    priceInfo,
    ctas,
    cookies,
    interstitial,
  },
  state: {
    bootstrap: null,
  },
  getters: {
    getBootstrap(state) {
      return state.bootstrap;
    },
    getProductBySku: (state, getters) => (sku) => {
      const bootstrap = getters.getBootstrap;

      return bootstrap.skus[sku];
    },
  },
  mutations: {
    setBootstrap(state, payload) {
      state.bootstrap = payload;
    },
  },
  actions: {
    setBootstrap({ commit, dispatch }) {
      const bsData = { ...window.GarminAppBootstrap };
      commit('setBootstrap', bsData);
      dispatch('setInitState');
    },
    async setInitState({ dispatch, getters }) {
      const bootstrap = getters.getBootstrap;
      const {
        translations,
        sku,
        skus,
        filterDropdownList,
        devicesTabTitle,
      } = bootstrap;
      const product = skus[sku];

      // removing bad options from the list
      const productEmsList = bootstrap.productEmsList
        .filter((option) => Object.entries(option).length !== 0);

      const productOptionsList = {
        productEmsList,
        filterDropdownList,
      };

      const { tabs } = product;
      dispatch('setGlobalState', bootstrap);
      dispatch('setContent', translations);
      dispatch('setDevicesTabTitle', devicesTabTitle);
      dispatch('setProductOptionsList', productOptionsList);
      dispatch('setProductData', product);
      dispatch('setProductTabs', tabs);
      dispatch('setPromoBanner', bootstrap.promoBanner);
    },
    updateProductData({ dispatch, getters }, sku) {
      const product = getters.getProductBySku(sku);
      const { tabs } = product;
      const tabsSettings = {
        tabsPayload: tabs,
      };

      dispatch('setProductData', product);
      dispatch('updateProductTabs', tabsSettings);
      dispatch('resetInterstitial');
    },
    setProductData({ dispatch, getters }, product) {
      const optionsList = getters.getProductEmsList;

      const {
        images,
        price,
        actions,
        expressWarning,
        options,
        sidebar,
        spinner,
      } = product;
      const priceInfoState = {
        priceData: price ? { ...price } : null,
      };
      const ctasState = {
        actions: { ...actions },
        expressWarning,
      };
      const optionsData = {
        optionsList,
        options,
      };

      dispatch('setGallery', images);
      dispatch('setProductInfo', product);
      dispatch('setProductOptions', optionsData);
      dispatch('setPriceInfo', priceInfoState);
      dispatch('setSidebar', sidebar);
      dispatch('setCtas', ctasState);
      dispatch('initSpinner', spinner);
    },
  },
};

export default new Vuex.Store(storeSettings);
